(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oh-logo-motion-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oh-logo-motion')) {
    customElements.define('oh-logo-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.button || !CSS.supports('selector(:has(*))')) return;
        this.strip = this.closest('.oh-logo-strip');
        this.button = this.querySelector('button');
        if (!this.strip || !this.button) return;
        this.toggleMotion = () => {
          const paused = !this.strip.hasAttribute('data-oh-logo-paused');
          this.strip.toggleAttribute('data-oh-logo-paused', paused);
          this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        };
        this.button.addEventListener('click', this.toggleMotion);
        this.strip.setAttribute('data-oh-logo-ready', '');
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.toggleMotion);
        this.button = null;
        this.strip = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
